import ToggleItem from "../Common/ToggleItem";
import CommonToggleContainer from "../Common/CommonToggleContainer";

const {ccclass, property} = cc._decorator;

@ccclass
export default class RankingListUI extends cc.Component {
    @property(CommonToggleContainer)
    toggleContainerRankType: CommonToggleContainer = null
    
    @property(CommonToggleContainer)
    toggleContainerDateType: CommonToggleContainer = null
    
    onRankTypeToggleSelected (toggle: ToggleItem) {
    }

    onTimeToggleSelected (toggle: ToggleItem) {
    }

    onBtnClick (event, userData) {
        if (userData === "close") {
            this.node.destroy()
        }
    }
}
